import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=31156f0c&scoped=true&"
import script from "./ProjectForm.vue?vue&type=script&lang=js&"
export * from "./ProjectForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&id=31156f0c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31156f0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/jenkins/workspace/asuparticipa_mapaasu_master-EEJDLXD2Q2AH3UKHZ3KLQPDLCS2LEPGUHAV53OMBNNN5YUGCSZCQ/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VFlex,VLayout,VTab,VTabItem,VTabs})
